import { Identify } from "./types";

const identify = ({ id, ...rest }: Identify): void => {
  window.analytics.identify(id, rest);
};

export { identify };
